exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/layouts/index.css
// module id = ./src/layouts/index.css
// module chunks = 17241999800008180000